import { API_CREDENTIALS, API_ENDPOINTS } from "./apiEndpoints";
import axiosClient from "./axiosClient";

export const sendOTP = ({ email }) =>
  axiosClient.post(
    API_ENDPOINTS.SEND_OTP,
    {
      email: email,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,

        "Accept-Language": "en",
        platform: "android",
        "platform-key": "387666a26a0ad869c9.00802837",
        "leap-customer": "yes",
      },
    }
  );

export const verifyOTP = ({ email, otp }) =>
  axiosClient.post(
    API_ENDPOINTS.VERIFY_OTP,
    {
      email: email,
      confirm_code: otp,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        "Accept-Language": "en",
        platform: "android",
        "platform-key": "387666a26a0ad869c9.00802837",
        "leap-customer": "yes",
      },
    }
  );
